<div class="flex flex-column h-full">
  <p class="mb-3 font-normal" translate>iFrame.Subscription.EnterAddrInfo</p>
  <bi-skip-link [label]="'accessibility.GoBack' | translate" (onClick)="onBack.emit()" />

  <zip-street-number-input
    id="test-address-selector"
    [showResultList]="true"
    [countryId]="countryId"
    buttonLabelTranslationKey="shared.SubscribeShort"
    (onAddressSelected)="onAddressSelected($event)"
  />
  <p-button class="mt-3 sm:mt-auto w-full" [ariaLabel]="'shared.Back' | translate" [label]="'shared.Back' | translate" (click)="onBack.emit()" />
</div>
